import React from "react";
import { Input } from "semantic-ui-react";

export default function SimpleInputComponent({
  name,
  label = "",
  placeholder = "",
  value,
  onChange = () => {},
  onSearch = () => {},
  className = "flex-row-center",
  labelClassName = "pr-1",
  selectClassName = "w-100",
  showAction = false,
  type = "text",
}) {
  return (
    <div className={className}>
      {label && (
        <label className={labelClassName}>
          <b>{label}</b>
        </label>
      )}
      <Input
        action={
          showAction
            ? {
                icon: "search",
                onClick: onSearch,
              }
            : undefined
        }
        className={selectClassName}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        type={type}
      />
    </div>
  );
}
